/* eslint-disable react-hooks/exhaustive-deps */
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'

import styled from 'styled-components'
import Routes from 'components/Routes/Routes'

const Wrap = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;

  h1 {
    margin-bottom: 20px;
  }

  button {
    background-color: var(--white);
    color: red;
    cursor: pointer;

    :hover {
      background-color: #2886ae;
      color: var(--white);
    }
  }
`

const NotFoundPage = () => {
  const navigate = useNavigate()
  const params = useParams()
  const { isLogin } = useSelector((state) => state.auth)
  const redirect = isLogin ? Routes.getUrl(Routes.dashboard.index) : '/login'

  useEffect(() => {
    if (params['*'].includes('lands')) return
    navigate(redirect)
  }, [])

  return (
    <Wrap>
      <Link to={redirect}>
        <h1>Not Found Page 404</h1>
        <button>BACK to HOME PAGE</button>
      </Link>
    </Wrap>
  )
}

export default NotFoundPage
